(() => {
  const prefix = 'unico-cart-preview:';
  const images = new Map();
  const inlineImage = async href => {
    if (href.startsWith('data:')) return href;
    if (!images.has(href)) images.set(href, fetch(href, {mode:'cors'}).then(r => {
      if (!r.ok) throw new Error('Preview image unavailable');
      return r.blob();
    }).then(blob => new Promise((resolve,reject) => {
      const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = reject; reader.readAsDataURL(blob);
    })));
    return images.get(href);
  };
  async function capture(root) {
    const source = root.querySelector('svg.unico-duo-preview__canvas');
    if (!source) return null;
    const svg = source.cloneNode(true);
    svg.setAttribute('xmlns','http://www.w3.org/2000/svg');
    svg.setAttribute('xmlns:xlink','http://www.w3.org/1999/xlink');
    const sourceStyle = getComputedStyle(source);
    [svg,...svg.querySelectorAll('*')].forEach(node=>{
      [...node.attributes].forEach(attribute=>{
        if(attribute.value.includes('var(')) node.setAttribute(attribute.name,attribute.value.replace(/var\((--[\w-]+)(?:,([^)]*))?\)/g,(_,name,fallback)=>sourceStyle.getPropertyValue(name).trim() || fallback || 'none'));
      });
    });
    if (root.dataset.coupleOnly !== 'true') {
      svg.querySelectorAll('[data-calibrated-shirt]').forEach(n=>{if(n.getAttribute('data-calibrated-shirt')!=='1')n.remove();});
      svg.setAttribute('viewBox','0 0 850 950');
    }
    svg.querySelectorAll('script,foreignObject').forEach(n => n.remove());
    await Promise.all([...svg.querySelectorAll('image')].map(async image => {
      const href = image.getAttribute('data-unico-href') || image.getAttribute('href') || image.getAttributeNS('http://www.w3.org/1999/xlink','href');
      if (!href) return;
      const data = await inlineImage(href);
      image.setAttribute('href',data); image.removeAttributeNS('http://www.w3.org/1999/xlink','href');
    }));
    const box = svg.getAttribute('viewBox').split(/\s+/).map(Number);
    const ratio = box[3]/box[2];
    const width = 440, height = Math.round(width * (ratio || 1));
    svg.setAttribute('width',width);svg.setAttribute('height',height);
    const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)],{type:'image/svg+xml;charset=utf-8'}));
    try {
      const image = new Image();
      await new Promise((resolve,reject) => {image.onload=resolve;image.onerror=reject;image.src=url;});
      const canvas = document.createElement('canvas');canvas.width=width;canvas.height=height;
      const context = canvas.getContext('2d');context.fillStyle='#f5f0e6';context.fillRect(0,0,width,height);context.drawImage(image,0,0,width,height);
      return canvas.toDataURL('image/png');
    } finally {URL.revokeObjectURL(url);}
  }
  window.unicoSaveCartPreview = async (root,items) => {
    try {
      const data = await Promise.race([capture(root),new Promise(resolve=>setTimeout(()=>resolve(null),3000))]);
      if (!data) return;
      const key = JSON.stringify(items.map(item=>({id:item.id,properties:item.properties})));
      let hash=2166136261;for(let i=0;i<key.length;i++) hash=Math.imul(hash^key.charCodeAt(i),16777619);
      const token=(hash>>>0).toString(36);
      const old = JSON.parse(localStorage.getItem(prefix+'index') || '[]').filter(k=>k!==token);
      while(old.length>=20)localStorage.removeItem(prefix+old.shift());
      localStorage.setItem(prefix+token,data);localStorage.setItem(prefix+'index',JSON.stringify([...old,token]));
      items.forEach(item=>{item.properties['_Aperçu UNICO']=token;});
    } catch (_) {}
  };
  const restore = () => {
    document.querySelectorAll('[data-unico-preview-key]').forEach(row=>{
      const image=row.querySelector('.cart-items__media-image');
      if(!image || image.dataset.unicoPreview===row.dataset.unicoPreviewKey)return;
      try {
        const data=localStorage.getItem(prefix+row.dataset.unicoPreviewKey);
        if(!data || !data.startsWith('data:image/png;base64,'))return;
        image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=data;
        image.dataset.unicoPreview=row.dataset.unicoPreviewKey;image.style.objectFit='contain';
      } catch (_) {}
    });
  };
  let frame;
  new MutationObserver(()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(restore);}).observe(document.body,{childList:true,subtree:true});
  restore();window.addEventListener('pageshow',restore);
})();
